<section class="selectable-orders-container">
  <span class="select-all"> </span>
  <span class="list-section">
    <app-selectable-order
      *ngFor="let order of orders"
      [orderObject]="order"
    ></app-selectable-order>
  </span>
</section>
